module.exports = __webpack_public_path__ + "static/media/live-chat.463c022d.svg";